var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.purchaseOption
    ? _c("SoliForm", {
        ref: "form",
        attrs: {
          title: `Edit ${_vm.isMembership ? "Membership" : "Pass"}`,
          saveChanges: !_vm.prorationLoading,
          hideBtn: !Object.values(_vm.editMode).some((e) => e),
        },
        on: {
          reset: function ($event) {
            return _vm.$emit("reset")
          },
          submit: function ($event) {
            return _vm.updateSubscription()
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "body",
              fn: function () {
                return [
                  !Object.values(_vm.editMode).some((e) => e)
                    ? _c(
                        "v-list",
                        [
                          _vm.isMembership
                            ? _c("SoliBtn", {
                                staticClass: "mb-3",
                                attrs: {
                                  block: "",
                                  text: "Withdraw with 30 Days Notice",
                                  color: "soli-grey",
                                  outlined: "",
                                },
                                on: {
                                  click: function ($event) {
                                    ;[
                                      (_vm.editMode.withdraw30 = true),
                                      _vm.getExitProration(),
                                      _vm.getFinalClass(),
                                    ]
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isMembership
                            ? _c("SoliBtn", {
                                staticClass: "mb-3",
                                attrs: {
                                  block: "",
                                  text: "Cancel at End of Billing Period",
                                  color: "soli-grey",
                                  outlined: "",
                                },
                                on: {
                                  click: function ($event) {
                                    ;[
                                      (_vm.editMode.endOfCycle = true),
                                      //(showEoMWarning = true),
                                      _vm.getFinalClass(),
                                    ]
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isMembership
                            ? _c("SoliBtn", {
                                staticClass: "mb-3",
                                attrs: {
                                  block: "",
                                  text: "Cancel Now",
                                  color: "soli-grey",
                                  outlined: "",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.editMode.cancelNow = true
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isMembership && _vm.purchaseOption.canUpgrade
                            ? _c("SoliBtn", {
                                staticClass: "mb-3",
                                attrs: {
                                  block: "",
                                  text: "Upgrade or Downgrade Membership",
                                  color: "soli-grey",
                                  outlined: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("changePrice")
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("SoliBtn", {
                            staticClass: "mb-3",
                            attrs: {
                              block: "",
                              text: "Change Price and Tags",
                              color: "soli-grey",
                              outlined: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("editDetails")
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.purchaseOption.pendingExit
                            ? _c("SoliBtn", {
                                staticClass: "mb-3",
                                attrs: {
                                  loading: _vm.removeExitLoading,
                                  block: "",
                                  outlined: "",
                                  text: "Remove Pending Exit Form",
                                  color: "soli-grey",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.removePendingExit(
                                      _vm.purchaseOption
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editMode.withdraw30
                    ? _c("SoliDate", {
                        attrs: {
                          label: "Date of Notice",
                          max: _vm.getSubscriptionCycleMax(
                            _vm.purchaseOption.cycle
                          ),
                          min:
                            _vm.globalMomentISO(_vm.purchaseOption.starts_at) >
                            _vm.globalMomentISOStartOfMonth(new Date())
                              ? _vm.globalMomentISO(
                                  _vm.purchaseOption.starts_at
                                )
                              : _vm.globalMomentISOStartOfMonth(new Date()),
                          rules: [
                            (val) =>
                              (val || "").length > 0 ||
                              "This field is required",
                          ],
                        },
                        on: {
                          input: function ($event) {
                            ;[_vm.getExitProration(), _vm.getFinalClass()]
                          },
                        },
                        model: {
                          value: _vm.dateOfNotice,
                          callback: function ($$v) {
                            _vm.dateOfNotice = $$v
                          },
                          expression: "dateOfNotice",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editMode.withdraw30
                    ? _c("div", { staticClass: "soli-grey pb-5 px-1" }, [
                        _vm._v(
                          "\n            Which lessons will be cancelled?\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editMode.withdraw30
                    ? _c(
                        "v-btn-toggle",
                        {
                          staticClass: "w-full",
                          attrs: { mandatory: "" },
                          model: {
                            value: _vm.cancelAll,
                            callback: function ($$v) {
                              _vm.cancelAll = $$v
                            },
                            expression: "cancelAll",
                          },
                        },
                        [
                          _c(
                            "v-col",
                            { staticClass: "pa-0 ma-0", attrs: { cols: "12" } },
                            [
                              _c("SoliBtn", {
                                staticClass: "mb-3",
                                attrs: {
                                  block: "",
                                  text: "Cancel lessons after exit date",
                                  color: "soli-grey",
                                  value: false,
                                  outlined: "",
                                },
                              }),
                              _vm._v(" "),
                              _c("SoliBtn", {
                                staticClass: "mb-3",
                                attrs: {
                                  block: "",
                                  text: "Cancel all lessons",
                                  color: "soli-grey",
                                  value: true,
                                  outlined: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editMode.cancelNow
                    ? _c("div", { staticClass: "soli-grey pb-5 px-1" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              `${_vm.purchaseOption.name} and all of its lessons will be cancelled immediately. If a refund should be issued, you'll still need to process it separately. This can't be undone.`
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editMode.endOfCycle
                    ? _c("div", { staticClass: "soli-grey pb-5 px-1" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              `${_vm.purchaseOption.name} will terminate at the end of the billing period.`
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editMode.withdraw30 ||
                  _vm.editMode.cancelNow ||
                  _vm.editMode.endOfCycle
                    ? _c(
                        "div",
                        [
                          _c("v-switch", {
                            staticClass: "mb-3",
                            attrs: { label: "Email Student", dense: "" },
                            model: {
                              value: _vm.emailStudent,
                              callback: function ($$v) {
                                _vm.emailStudent = $$v
                              },
                              expression: "emailStudent",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-switch", {
                            staticClass: "pt-0 mb-3 mt-0",
                            attrs: { label: "Email Teacher", dense: "" },
                            model: {
                              value: _vm.emailTeacher,
                              callback: function ($$v) {
                                _vm.emailTeacher = $$v
                              },
                              expression: "emailTeacher",
                            },
                          }),
                          _vm._v(" "),
                          _vm.editMode.withdraw30
                            ? _c(
                                "div",
                                { staticClass: "soli-grey pa-3 mb-3 row" },
                                [
                                  _c("div", { staticClass: "w-full" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          `Membership End Date: ${_vm.globalMomentDate(
                                            _vm.cancelAt
                                          )}`
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n\n                Final Invoice Amount:\n                "
                                  ),
                                  !_vm.prorationLoading
                                    ? _c("div", { staticClass: "mx-2" }, [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.formatUnitAmount(
                                                _vm.exitProration
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.prorationLoading
                                    ? _c("v-progress-circular", {
                                        staticClass: "mx-3",
                                        attrs: {
                                          indeterminate: "",
                                          size: 25,
                                          color: "primary",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.cancelAll
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              `Final ${
                                                _vm.purchaseOption.is_event
                                                  ? "Class"
                                                  : "Lesson"
                                              } Date: ${_vm.getFinalLessonDate}`
                                            ) +
                                            "\n                "
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editMode.endOfCycle && !_vm.cancelAll
                    ? _c("div", { staticClass: "soli-grey pa-3 mb-3 row" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              `Final ${
                                _vm.purchaseOption.is_event ? "Class" : "Lesson"
                              } Date: ${_vm.getFinalLessonDate}`
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editMode.changeDate
                    ? _c("SoliDate", {
                        attrs: {
                          rules: [
                            (val) =>
                              (val || "").length > 0 ||
                              "This field is required",
                          ],
                        },
                        model: {
                          value: _vm.anchor,
                          callback: function ($$v) {
                            _vm.anchor = $$v
                          },
                          expression: "anchor",
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          3256909520
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }